class FocusTrap {
    focusableSelectors =
        'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    constructor(modal, openBtn, includeOpenButton = false) {
        this._keyDown = this._keyDown.bind(this);

        this.modal = modal;
        this.openBtn = openBtn;
        this.includeOpenButton = includeOpenButton;
        this.focusableElements = [];

        if (this.modal && this.openBtn) {
            this.event();
        }
    }

    event() {
        this.modal.hidden = false;

        this.focusableElements = this.modal.querySelectorAll(
            this.focusableSelectors,
        );
        if (this.includeOpenButton) {
            this.focusableElements = Array.from(this.focusableElements);
            this.focusableElements.unshift(this.openBtn);
        }

        this.firstEl = this.focusableElements[0];
        this.lastEl = this.focusableElements[this.focusableElements.length - 1];
        setTimeout(() => {
            this.firstEl.focus();
        }, 100);

        this.firstEl.addEventListener("click", (e) => {
            e.preventDefault();
            this.closeModal();
        });

        document.addEventListener("keydown", this._keyDown);
    }

    _keyDown(event) {
        if (
            this.openBtn.getAttribute("aria-expanded") === "true" &&
            event.key === "Tab"
        ) {
            if (event.shiftKey) {
                if (document.activeElement === this.firstEl) {
                    event.preventDefault();
                    this.lastEl.focus();
                }
            } else {
                if (document.activeElement === this.lastEl) {
                    event.preventDefault();
                    this.firstEl.focus();
                }
            }
        }
    }

    closeModal() {
        this.modal.hidden = true;
        this.openBtn.focus();
    }
}

export default FocusTrap;
